module.exports = __webpack_public_path__ + "static/media/team-robert-kasten.7e54be1a.jpg";